// Espeja SICLIN-BACK/api/models_abstract.py:132-141 (Insumos_Medicamentos.lista_grupo_producto)
// para poder filtrar el catálogo cacheado (dictAllSupplies) por categoría en el cliente,
// en vez de pedirle cada categoría al backend por separado.
export function listaGrupoProducto(tipo) {
  if (tipo === "Insumos") {
    return ["Insumos", "Articulos", "Alimentos"];
  }
  if (tipo === "Insumos-Medicamentos") {
    return ["Insumos", "Articulos", "Alimentos", "Medicamentos"];
  }
  return [tipo];
}

export function filterSuppliesByGroup(supplies, tipo) {
  if (!tipo) {
    return supplies;
  }
  const grupos = listaGrupoProducto(tipo);
  return supplies.filter(supply => grupos.includes(supply.grupo_producto));
}
